import i18n from '@/modules/i18n'

const locale = 'ptbr'
const locales = []
const scopes = require.context(__dirname, true, /ptbr.js$/)

scopes.keys().forEach((file) => locales.push(scopes(file).default))

export default i18n({ locale, locales })
